// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__9fWH-","imageContainer":"Banner_imageContainer__lfwru","image":"Banner_image__9+-ud","fadeIn":"Banner_fadeIn__bQZYW"};